module.exports = __webpack_public_path__ + "img/zen.eeeb9e83.png";